export class ContractPersonModel {
    contractPersonId = 0;
    contractId = 1;
    personId = 0;
    name = "";
    file = null;
}
